export default __webpack_public_path__ + "static/media/seniorCitizenGraph-4.63ea6b2b.jpeg";